import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableBody, TableHead, TableRow, Tooltip} from "@material-ui/core";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportConflictEditForm from "./AnnualReportConflictEditForm";
import annualReportSteps from "../../constants/annualReportSteps";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";
import AnnualReportTablePart from "../common/AnnualReportTablePart";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import formatInteger from "libs/formatInteger";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";
import Tr from "translations/Translations";
import annualReportTenderMode from "../../constants/annualReportTenderMode";

const reportStep = annualReportSteps.conflict;

function AnnualReportConflictForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict, dictTranslations} = useContext(FormTranslationContext);
    const [types] = useState(getDict("MP.MMiA.OrdersType"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});

    const getRowValues = (entry) => ([
        entry.number,
        entry.source ? dictTranslations.source[entry.source] : null,
        entry.noticeNumber,
        entry.orderType ? dictTranslations.orderType[entry.orderType] : null,
        entry.codeCpv ? <Tooltip title={entry.codeCpv.name}><span>{entry.codeCpv.publicCode}</span></Tooltip> : null,
        annualReportTenderMode(entry, dictTranslations),
        formatInteger(entry.numberOfCasesOfConflictOfInterest),
        formatInteger(entry.numberOfDetectedAgreements),
        formatInteger(entry.numberOfContractorsWithRejectedOffer),
    ])

    if (!initValues) return <Loading/>
    return <>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    <AnnualReportTableHeadCell label="mmia.conflict.number" rowSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.conflict.source" rowSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.conflict.noticeNumber" rowSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.conflict.orderType" rowSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.conflict.codeCpv" rowSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.conflict.tenderModeBzp" rowSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.conflict.numberOfCasesOfConflictOfInterest" rowSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.conflict.complete" colSpan={2} borderRight/>
                    <AnnualReportTableCell borderLeft borderRight rowSpan={2} colSpan={2}></AnnualReportTableCell>
                </TableRow>
                <TableRow>
                    <AnnualReportTableHeadCell label="mmia.conflict.numberOfDetectedAgreements"/>
                    <AnnualReportTableHeadCell label="mmia.conflict.numberOfContractorsWithRejectedOffer"/>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    types.map((type) =>
                        <AnnualReportTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            reportStep={reportStep}
                            partName={dictTranslations.type[type.value]}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                            columnCount={9}
                            getRowValues={getRowValues}
                        />
                    )
                }
            </TableBody>

        </Table>

        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={annualReportSteps.conflict}
                FormComponent={AnnualReportConflictEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.filter((item) => item.value !== movePopup.currentType)}
                onClose={() => setMovePopup(null)}
                inputLabel={Tr("order_type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }
    </>


}

AnnualReportConflictForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportConflictForm;